'use strict';

var formCheck = require('../forms/check/_index');

window.recaptchaContactUs = function () {
    let element = document.querySelector('#ct-g-recaptcha-response');
    if (element) {
        let mandatoryFieldsFilled = element.closest('form').extendedData.mandatoryFieldsFilled;
        let elId = element.id;
        if (arguments && arguments[0]) {
            var token = arguments[0];
            element.value = token;
            if (mandatoryFieldsFilled !== undefined) {
                mandatoryFieldsFilled[elId] = true;
            } else {
                element.closest('form').extendedData.mandatoryFieldsFilled = [];
                element.closest('form').extendedData.mandatoryFieldsFilled[elId] = true;
                mandatoryFieldsFilled = element.closest('form').extendedData.mandatoryFieldsFilled;
            }
        } else if (mandatoryFieldsFilled !== undefined) {
            element.value = '';
            delete (element.closest('form').extendedData.mandatoryFieldsFilled[elId]);
        }
        formCheck.manageSubmitButtonDisability(element, mandatoryFieldsFilled);
    }
};
